import { BaseModel } from '@app/core/models/base.model';
import { UserStats, UserBundle } from '@app/core/models/bundle-permission.model';

export class User extends BaseModel {
  public dob: string | null = null;
  public role: string | null = null;
  public email: string | null = null;
  public apiKey?: string | null = null;
  public position: string | null = null;
  public moreInfo: string | null = null;
  public lastName: string | null = null;
  public firstName: string | null = null;
  public accountType: string | null = null;
  public phoneNumber?: number | null = null;
  public lastActivityAt?: Date | null = null;
  public workingSector: string | null = null;
  public profilePicture?: string | null = null;
  public wallet?: any | null = null;
  public isActiveBundle: boolean = false;
  public isLimitExceeded: boolean = false;
  public userStats: any | null = new UserStats();
  public userBundle: any | null = new UserBundle();

  constructor(values?: any) {
    super();
    this.active = false;
    if (values && Object.keys(values)?.length) {
      Object.assign(this, values);
      if (values.userStats && Object.keys(values.userStats).length) {
        this.userStats = new UserStats(values.userStats);
      } else {
        this.userStats = new UserStats();
      }
      if (values.userBundle?.id) {
        this.userBundle = new UserBundle(values.userBundle);
      }
    }
  }

  public hasPermission(
    property: keyof {},
    propertyType: 'boolean' | 'number' = 'boolean',
    ignoreLimitExceededCheck: boolean = false,
  ): boolean {
    const userStats: any = this.userStats || {};
    const bundle: any = this.userBundle?.bundle || {};
    if (bundle[property] === null) {
      return false;
    }
    if (this.isLimitExceeded && !ignoreLimitExceededCheck) {
      return this.checkPermissionForTrainOrInference(property) ? true : false;
    }
    if (propertyType === 'boolean') {
      return bundle[property] === true;
    } else if (propertyType === 'number') {
      if (typeof bundle[property] === 'number' && bundle[property] === 0) {
        return true;
      }
      return bundle[property] !== null;
    }
    return false;
  }

  public checkLimitExceedByProperty(property: keyof {}, quotaProperty: keyof {}): boolean {
    if (this.userBundle?.isLimitExceeded) {
      return true;
    }
    const userStats: any = this.userStats || {};
    const bundle: any = this.userBundle?.bundle || null;
    return userStats &&
      bundle &&
      bundle[property] > 0 &&
      userStats[quotaProperty] > bundle[property]
      ? true
      : false;
  }

  private checkForQuotaExceedByStatProperty(property: keyof {}, bundleProperty: keyof {}) {
    if (this.checkIsLimitExceedByStatAndBundleProperty(property, bundleProperty)) {
      this.freezeUserAccount();
    }
  }

  private checkPermissionForTrainOrInference(property: keyof {}): boolean {
    const userStats: any = this.userStats || {};
    const bundle: any = this.userBundle?.bundle || {};
    return (
      bundle[property] > 0 &&
      (property === 'inferenceCost' || property === 'trainingCost') &&
      (userStats.privateDatasetsCount <= bundle.privateDatasets ||
        userStats.privateProjectsCount <= bundle.privateProjects)
    );
  }

  private checkIsLimitExceedByStatAndBundleProperty(
    property: keyof {},
    bundleProperty: keyof {},
  ): boolean {
    const bundle: any = this.userBundle?.bundle || {};
    return this.userStats![property] > bundle![bundleProperty];
  }

  private freezeUserAccount(): void {
    this.isLimitExceeded = this.userBundle!.isLimitExceeded = true;
    this.isActiveBundle = false;
  }
}
